module.exports = __webpack_public_path__ + "static/media/unicef_app_login.4f6acf81.jpg";